module.exports = __webpack_public_path__ + "img/cs_ruckus_logo.6ba69f18.png";